import { listAssignableAccounts as listAssignableAccountsApi } from '@shared/api/accounts';
import type { AssignableAccount } from '@shared/types/account';

/// 担当者候補 (assignable accounts) の共有ストア。
///
/// 契約一覧の担当者列や担当者セレクトで id → 表示名を解決するための候補で、
/// 詳細ページ単位で 1 回ロードすれば十分。`/api/accounts/assignable` は admin proxy の
/// read-only DTO なので domain parse は不要 (型のまま保持)。担当者名解決は付加情報のため、
/// 失敗しても空配列にフォールバックして契約一覧自体は id 表示で成立させる。

interface State {
  data: AssignableAccount[];
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

const state = $state<State>({ data: [], loading: false, loaded: false, error: null });
let token = 0;

export const assignableAccountsStore = {
  get data(): AssignableAccount[] {
    return state.data;
  },
  get loading(): boolean {
    return state.loading;
  },
  /// ロード試行が一度でも完了したか。担当者ありの行を「(未割当)」と取り違えないため、
  /// 「読み込み中」と「解決不能」を区別する判定に使う。
  get loaded(): boolean {
    return state.loaded;
  },
  get error(): string | null {
    return state.error;
  },
  /// 担当者候補をロードする。失敗時も loaded を立て、再試行ループを避ける。
  async load(): Promise<void> {
    const current = ++token;
    state.loading = true;
    state.error = null;
    try {
      const accounts = await listAssignableAccountsApi();
      if (current !== token) return;
      state.data = accounts;
    } catch (err) {
      if (current !== token) return;
      state.data = [];
      state.error = err instanceof Error ? err.message : String(err);
    } finally {
      if (current === token) {
        state.loading = false;
        state.loaded = true;
      }
    }
  },
  clear(): void {
    token++;
    state.data = [];
    state.loading = false;
    state.loaded = false;
    state.error = null;
  },
};
